import * as React from "react";

import { ChainId } from "@usedapp/core";
import { useMemo } from "react";
import { Fade, Modal } from "@mui/material";
import styled from "@emotion/styled";
import themes from "../../themes";

export interface ChainModalProps {
  readonly chainId: ChainId | undefined;
}

export default function ChainModal({ chainId }: ChainModalProps) {
  const open = useMemo(() => {
    if (chainId == undefined) {
      return false;
    }
    return process.env.REACT_APP_CHAIN_ID !== chainId.toString();
  }, [chainId]);

  const network =
    process.env.REACT_APP_CHAIN_ID === "4" ? "Rinkeby" : "Mainnet";

  return (
    <div style={{ zIndex: 1300 }}>
      <StyledModal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
      >
        <StyledFade in={open}>
          <div>
            <h2>Switch to a supported Ethereum network</h2>
            <p>Please switch network to {network}.</p>
          </div>
        </StyledFade>
      </StyledModal>
    </div>
  );
}

const StyledModal = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledFade = styled(Fade)`
  background-color: #fff;
  border: 2px solid ${themes.palette.primary.main};
  box-shadow: ${themes.shadows[5]};
  padding: ${themes.spacing(2, 2, 2)};

  h2 {
    color: ${themes.palette.primary.main};
  }
`;
